import React from 'react';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { DeliverablesSection } from '../components/DeliverablesSection';
import { AudienceSection } from '../components/AudienceSection';
import { WhyWorksSection } from '../components/WhyWorksSection';
import { PricingSection } from '../components/PricingSection';
import { FaqSection } from '../components/FaqSection';
import { ClosingSection } from '../components/ClosingSection';
export function SalesPage() {
  return <div className="min-h-screen bg-[#0a0a0a] text-white selection:bg-amber-500/30" data-id="element-180">
      <Navigation data-id="element-181" />
      <main data-id="element-182">
        <HeroSection data-id="element-183" />
        <PainSection data-id="element-184" />
        <ProblemSection data-id="element-185" />
        <MechanismSection data-id="element-186" />
        <DeliverablesSection data-id="element-187" />
        <AudienceSection data-id="element-188" />
        <WhyWorksSection data-id="element-189" />
        <PricingSection data-id="element-190" />
        <FaqSection data-id="element-191" />
        <ClosingSection data-id="element-192" />
      </main>
    </div>;
}